<template>
  <v-expansion-panel v-model="panel" expand>
    <v-expansion-panel-content>
      <template v-slot:header>
        <h2>Roles</h2>
      </template>
      <v-card>
        <v-card-text>
          <table border="1">
            <tr>
              <th>Username</th>
              <th>Rolename</th>
              <th>Version</th>
            </tr>
            <tr v-for="userRole in entity.userRoles" :key="userRole.rolename">
              <td>{{ userRole.username }}</td>
              <td>{{ userRole.rolename }}</td>
              <td>{{ userRole.version }}</td>
            </tr>
          </table>
          <v-alert :value="!entity.userRoles" type="warning"
            >No user roles</v-alert
          >
          <div class="ajaxForm">
            <v-select
              v-model="rolesSelected"
              :items="roles"
              item-text="name"
              item-value="name"
              attach
              chips
              label="Roles"
              multiple
            />
            <v-btn @click="updateRoles"> <v-icon>save</v-icon>Save </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ROLES from "@/graphql/directory/Roles";
import UPDATE_ENTITY_USER_ROLES from "@/graphql/directory/UpdateEntityUserRoles";
export default {
  name: "Roles",
  props: ["entity", "lastUpdated"],
  apollo: {
    roles: {
      query: ROLES,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      panel: [],
      rolesSelected: null
    };
  },
  methods: {
    async updateRoles() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_USER_ROLES,
        variables: {
          id: Number(this.$route.params.id),
          roles: this.rolesSelected
        }
      });
      this.$emit("triggerUpdate");
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        if (this.entity.userRoles && this.entity.userRoles.length > 0) {
          this.rolesSelected = this.entity.userRoles.map((userRole) => {
            return userRole.rolename;
          });
        }
      }
    }
  }
};
</script>
